import React from 'react';

export const ENPOWER_LOGO_SRC = '/enpower-logo-transparent.png';
export const ENPOWER_LOGO_ON_DARK_SRC = '/enpower-logo-transparent-on-dark.png';

const LOGO_ASPECT_RATIO = 1029 / 132;

const logoHeights = {
  sm: 18,
  md: 24,
  lg: 32,
  xl: 42,
};

const parsePixelSize = (value, fallback) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  const parsed = Number.parseFloat(String(value || '').replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : fallback;
};

const shouldUseOnDarkLogo = (variantOrColor) => {
  const value = String(variantOrColor || '').trim().toLowerCase();
  return value === 'light' || value === 'on-dark' || value === '#fff' || value === '#ffffff' || value === 'white' || value.startsWith('rgb(255, 255, 255') || value.startsWith('rgba(255,255,255') || value.startsWith('rgba(255, 255, 255');
};

const logoWidthForHeight = (height) => Math.round(height * LOGO_ASPECT_RATIO);

const EnPowerLogoImage = ({
  className = '',
  height = logoHeights.md,
  onDark = false,
  display = 'inline-flex',
  verticalAlign = 'middle',
  style = {},
}) => {
  const width = logoWidthForHeight(height);
  const src = onDark ? ENPOWER_LOGO_ON_DARK_SRC : ENPOWER_LOGO_SRC;

  return (
    <span
      className={className || undefined}
      style={{
        display,
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: `${width}px`,
        height: `${height}px`,
        padding: 0,
        background: 'transparent',
        borderRadius: 0,
        boxShadow: undefined,
        lineHeight: 0,
        flex: '0 0 auto',
        boxSizing: 'content-box',
        verticalAlign,
        ...style,
      }}
    >
      <img
        src={src}
        alt="EN:POWER Logo"
        loading="eager"
        decoding="async"
        draggable="false"
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'left center',
          userSelect: 'none',
        }}
      />
    </span>
  );
};

export const EnPowerLogo = ({ size = 'md', variant = 'full', className = '', style = {} }) => (
  <EnPowerLogoImage
    className={className}
    height={logoHeights[size] || logoHeights.md}
    onDark={shouldUseOnDarkLogo(variant)}
    style={style}
  />
);

export const EnPowerLogoText = ({ size = 'md', variant = 'light', className = '', style = {} }) => (
  <EnPowerLogoImage
    className={className}
    height={logoHeights[size] || logoHeights.md}
    onDark={shouldUseOnDarkLogo(variant)}
    style={style}
  />
);

export const EnPowerWordmarkInline = ({
  enColor = '#122A5C',
  fontSize = '12px',
  className = '',
  style = {},
}) => {
  const height = Math.max(6, Math.round(parsePixelSize(fontSize, 12) * 10) / 10);

  return (
    <EnPowerLogoImage
      className={className}
      height={height}
      onDark={shouldUseOnDarkLogo(enColor)}
      verticalAlign="-0.12em"
      style={style}
    />
  );
};
